class NordicFiltersToggle extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.closest('.collection-wrapper--nordic-filters');
    this.section = this.closest('.shopify-section');

    if (!this.wrapper || !this.section) return;

    this.storageKey = `rughaus:nordic-filters:${this.wrapper.dataset.nordicFilters || window.location.pathname}`;
    this.drawerStorageKey = `${this.storageKey}:drawer`;

    this.removeEventListener('click', this.handleClick);
    this.addEventListener('click', this.handleClick);
    this.section.removeEventListener('change', this.handleFilterChange, true);
    this.section.addEventListener('change', this.handleFilterChange, true);
    this.section.removeEventListener('close', this.handleDrawerClose, true);
    this.section.addEventListener('close', this.handleDrawerClose, true);

    this.sectionObserver?.disconnect();
    this.sectionObserver = new MutationObserver(this.restoreState);
    this.sectionObserver.observe(this.section, { childList: true, subtree: true });

    this.restoreState();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.section?.removeEventListener('change', this.handleFilterChange, true);
    this.section?.removeEventListener('close', this.handleDrawerClose, true);
    this.sectionObserver?.disconnect();
  }

  handleClick = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('button')) return;

    this.wrapper = this.closest('.collection-wrapper--nordic-filters');
    if (!this.wrapper) return;

    this.setOpen(!this.wrapper.classList.contains('nordic-filters-open'));
  };

  handleFilterChange = (event) => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.name.startsWith('filter.')) return;

    if (event.target.closest('#filters-drawer dialog[open]')) {
      sessionStorage.setItem(this.drawerStorageKey, 'open');
    }
  };

  handleDrawerClose = (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.closest('#filters-drawer')) {
      sessionStorage.setItem(this.drawerStorageKey, 'closed');
    }
  };

  restoreState = () => {
    this.wrapper = this.closest('.collection-wrapper--nordic-filters');
    this.button = this.querySelector('button');

    if (!this.wrapper || !this.button) return;

    // Open filters by default; retain an explicit choice to close them during this session.
    this.applyOpenState(sessionStorage.getItem(this.storageKey) !== 'closed');

    if (window.matchMedia('(max-width: 749px)').matches) {
      const drawer = this.section?.querySelector('#filters-drawer');
      const dialog = drawer?.querySelector('dialog');

      if (
        sessionStorage.getItem(this.drawerStorageKey) === 'open' &&
        dialog &&
        !dialog.open &&
        !drawer.hasAttribute('data-nordic-restore-pending') &&
        typeof drawer.showDialog === 'function'
      ) {
        drawer.setAttribute('data-nordic-restore-pending', '');
        drawer.showDialog();
        requestAnimationFrame(() => drawer.removeAttribute('data-nordic-restore-pending'));
      }
    }
  };

  setOpen(isOpen) {
    this.applyOpenState(isOpen);
    sessionStorage.setItem(this.storageKey, isOpen ? 'open' : 'closed');
  }

  applyOpenState(isOpen) {
    this.wrapper.classList.toggle('nordic-filters-open', isOpen);
    this.button.setAttribute('aria-expanded', String(isOpen));

    const symbol = this.button.querySelector('.nordic-filters-toggle__symbol');
    const symbolText = isOpen ? '−' : '+';
    if (symbol && symbol.textContent !== symbolText) {
      symbol.textContent = symbolText;
    }
  }
}

if (!customElements.get('nordic-filters-toggle')) {
  customElements.define('nordic-filters-toggle', NordicFiltersToggle);
}
